// staffModeEarly.js — pre-paint staff stamp. BLOCKING, first children of
// <body> in base.njk (same slot/pattern as the FOUC theme script): runs in
// the same synchronous parse step as <body>, so body.staffMode is present
// before the FIRST paint. External file on purpose — CSP is 'self' + hashes
// only, and a new inline script would need a hash allowlist on every box
// (see vm-lab/frontend/fouc-fix.md).
//
// Why: staffNav.js's account fetch is async, so without this stamp every
// page load paints the non-staff nav first (help icon visible, shield hidden)
// and then flips for staff — a one-frame swap. staffNav.js persists its
// verdict to localStorage ('staffNavRole'); on repeat visits we apply it
// here, synchronously. First visit after a role change still settles one
// frame late — once per role change, accepted.
try {
  if (localStorage.getItem('staffNavRole') === 'staff') {
    document.body.classList.add('staffMode');
  }
  // Role-number stamp for link-level gating (trash bin = Root-only, ruling
  // 2026-10-18). Same pre-paint slot, same localStorage tradeoff: first load
  // after a role change settles one frame late (accepted, same as staffMode).
  var staffRoleNum = localStorage.getItem('staffNavRoleNum');
  if (staffRoleNum !== null) {
    document.body.classList.add('staffRole' + staffRoleNum);
  }
} catch (e) { /* private mode / storage disabled — staffNav.js settles it */ }
